import React from "react";
import "./Home.scss";
import Hero from "../../Section/Hero/Hero";
import About from "../../Section/About/About";
import Promo from "../../Section/Promo/Promo";
import Facilities from "../../Section/Facilities/Facilities";
import Product from "../../Section/Product/Product";
import Location from "../../Section/Location/Location";
import ScrollToAnchor from "./ScrollToAnchor";

const Home = () => {
  return (
    <div className="home">
      <ScrollToAnchor />
      <Hero />
      <About />
      <Promo />
      <Facilities />
      <Product />
      <Location />
    </div>
  );
};

export default Home;
